import React, { useContext, useEffect, useState } from 'react'
import { auth, database ,storage } from '../firebase'

const AuthContext = React.createContext()
export function useAuth() {
    return useContext(AuthContext)
}
export default function AuthProvider({ children }) {
    const [currentUser, setCurrentUser] = useState()
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            setCurrentUser(user)
            setLoading(false)
        });
        return unsubscribe
    }, [])
    function signup(email, password) {
        return auth.createUserWithEmailAndPassword(email, password)
    }
    function updateDisplayNameAndPhoto(displayName, photo) {

        var user = auth.currentUser
        if (user === null) return console.log("No user loged in ,authContext l:24");

        const uploadTask = storage.ref(`/profilePictures/${user.uid}`)
            .put(photo)
        return uploadTask.on('state_changed', snapshot => {
        }, () => {
            console.error("Error uploading !");
        }, () => {

            uploadTask.snapshot.ref.getDownloadURL().then(function (url) {
                user.updateProfile({
                    displayName: displayName,
                    photoURL: url
                }).then(() => {
                    setInUsersCollection();
                })
            })

        }
        )
    }


    function setInUsersCollection() {
        var user = auth.currentUser
        if (user === null) return console.error("User was not set yet !")
        return database.users.add({
            uid: user.uid,
            displayName: user.displayName,
            photoURL: user.photoURL,
        })
    }

    function sendVerificationEmail() {
        return auth.currentUser.sendEmailVerification()
    }
    function signin(email, password) {
        return auth.signInWithEmailAndPassword(email, password)
    }
    function signout() {
        return auth.signOut()
    }
    function resetPassword(email) {
        return auth.sendPasswordResetEmail(email)
    }
    const value = {
        currentUser,
        signup,
        signin,
        signout,
        resetPassword,
        setInUsersCollection,
        updateDisplayNameAndPhoto,
        sendVerificationEmail
    }

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    )
}
